<template>
  <fragment>
    <mc-app-header title="Home" />
    <mc-app-body>
      <div class="section">
        <p class="content is-large">
          Welcome! This is MadamCurious Admin!
        </p>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
export default {};
</script>

<style></style>
